import apiClient from './apiClient';

const obtenerConfig = () => apiClient.get('/admin/anses/config').then((r) => r.data);

const actualizarConfig = (dto) => apiClient.put('/admin/anses/config', dto).then((r) => r.data);

const obtenerStatus = () => apiClient.get('/admin/anses/status').then((r) => r.data);

const obtenerLogs = (limit = 50) => apiClient.get('/admin/anses/logs', { params: { limit } }).then((r) => r.data);

const ansesAdminService = { obtenerConfig, actualizarConfig, obtenerStatus, obtenerLogs };

export default ansesAdminService;
